import { render } from "./HeroList.vue?vue&type=template&id=870b7c6c&scoped=true"
import script from "./HeroList.vue?vue&type=script&lang=js"
export * from "./HeroList.vue?vue&type=script&lang=js"

import "./HeroList.vue?vue&type=style&index=0&id=870b7c6c&scoped=true&lang=css"

import exportComponent from "/Users/gaomingliang/github/vue3_wzheros/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-870b7c6c"]])

export default __exports__